import dayjs from "dayjs";
import { Avatar, Box, Button, CircularProgress, Grid, Skeleton, Typography } from "@mui/material";
// import utc from "dayjs/plugin/utc";
// import timezone from "dayjs/plugin/timezone";
import { gridSpacing } from "../../../store/constants";
import { useTheme } from "@mui/material/styles";
import SendIcon from "@mui/icons-material/Send";
import { useEffect, useState } from "react";
import { openSuccessDialog } from "../../../utils/ui-components/pop-ups/SuccessDialog";
import CloseIcon from "@mui/icons-material/Close";
import { ReportService } from "../../../assets/_services/report-service";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { CampaignService } from "../../../assets/_services/campaign-service";

// Load the plugins
// dayjs.extend(utc);
// dayjs.extend(timezone);

function ApproveSmsBulkCampaign({ initialItem, setOpen, fetchData, initialData }: any) {
  const theme: any = useTheme();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [contactList, setContactList] = useState([]);
  const [contactListLoading, setContactListLoading] = useState(false);

  useEffect(() => {
    if (Number(initialItem?.is_personalized_campaign) === 0) {
      setContactListLoading(true);
      const formData = {
        campaignId: initialItem.id,
      };
      CampaignService.getCampaignCreatedNumberList(formData).then((response) => {
        if (response.isSuccess) {
          setContactList(response.data.data);
          setContactListLoading(false);
        } else {
          setContactList([]);
          setContactListLoading(false);
        }
      });
    }
  }, []);

  const ApproveCampaign = (status: number) => {
    setIsLoading(true);
    if (Number(initialData?.role) === 3) {
      ReportService.approveFirstApproverCampaings({
        campaignId: initialItem.id,
        status: status,
      }).then((response) => {
        if (response.isSuccess) {
          openSuccessDialog("Success", `${response.data.comment}`);
          setIsLoading(false);
          fetchData();
          setOpen(false);
        } else {
          setIsLoading(false);
        }
      });
    } else {
      ReportService.approveSecondApproverCampaings({
        campaignId: initialItem.id,
        status: status,
      }).then((response) => {
        if (response.isSuccess) {
          openSuccessDialog("Success", `${response.data.comment}`);
          setIsLoading(false);
          fetchData();
          setOpen(false);
        } else {
          setIsLoading(false);
        }
      });
    }
  };

  return (
    <Grid container justifyContent="center" spacing={2}>
      <Grid item xs={12}>
        <Box
          sx={{
            padding: "15px",
          }}
        >
          <Grid container spacing={gridSpacing}>
            <Grid item container xl={8} lg={8} md={7.5} xs={12} justifyContent={"center"} alignContent={"space-between"}>
              <Grid
                item
                sx={{
                  border: "1px solid",
                  borderColor: theme.palette.primary.light,
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
                  borderRadius: "10px",
                  py: "15px",
                  px: "10px",
                }}
                xs={12}
                container
                columnSpacing={1}
                rowSpacing={3}
                justifyContent={"center"}
              >
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Campaign Name :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{initialItem?.campaign_name}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Number Mask :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{initialItem?.mask}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Medium :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>SMS</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Channel :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{initialItem?.channel_name}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Start Date & Time :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{dayjs.utc(initialItem?.scheduled_timestamp).format("DD ddd, MMMM YYYY | hh:mm:ss a")}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    End Date & Time :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Typography>{dayjs.utc(initialItem?.expiry_timestamp).format("DD ddd, MMMM YYYY | hh:mm:ss a")}</Typography>
                </Grid>
                <Grid item xs={4}>
                  <Typography variant="caption" fontWeight={"bold"}>
                    Audience Base :
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  {Number(initialItem?.is_personalized_campaign) === 1 ? (
                    <Typography display="flex" alignItems="center">
                      <ArrowRightIcon sx={{ marginRight: 1 }} /> Personalized File Upload
                    </Typography>
                  ) : contactListLoading ? (
                    <>
                      <Skeleton />
                      <Skeleton />
                      <Skeleton />
                    </>
                  ) : (
                    contactList.map((item: any, index: number) => (
                      <Typography key={index} display="flex" alignItems="center">
                        <ArrowRightIcon sx={{ marginRight: 1 }} /> {item.contact_list_name}
                      </Typography>
                    ))
                  )}
                </Grid>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  justifyContent: "space-around",
                }}
              >
                <Button
                  color="error"
                  variant="contained"
                  type="button"
                  onClick={() => ApproveCampaign(0)}
                  startIcon={<CloseIcon />}
                  disabled={isLoading}
                >
                  Reject
                </Button>
                {/* <Box sx={{ width: 10 }} /> */}
                <Button
                  color="primary"
                  variant="contained"
                  type="button"
                  onClick={() => ApproveCampaign(1)}
                  startIcon={isLoading ? <CircularProgress size={"20px"} sx={{ mr: 1, color: "gray" }} /> : <SendIcon />}
                  disabled={isLoading}
                >
                  Approve
                </Button>
              </Grid>
            </Grid>
            <Grid item xl={4} lg={4} md={4.5} xs={12} container justifyContent="center">
              {Number(initialItem?.is_personalized_campaign) === 1 && (
                <Typography sx={{ mb: 1, px: 1 }}>
                  <b>Please note:</b> In personalized SMS campaigns, the message content may vary for each number.
                </Typography>
              )}
              <Box
                style={{
                  backgroundImage: `url(${require(theme.palette.mode === "light"
                    ? "../../../assets/images/ada_light_phone_background.PNG"
                    : "../../../assets/images/ada_dark_phone_background.PNG")})`,
                  width: "250px",
                  height: "440px",
                  overflowY: "auto",
                  backgroundSize: "cover",
                  borderRadius: 15,
                  border: `1px solid ${theme.palette.mode === "light" ? theme.palette.primary.light : theme.palette.secondary.main}`,
                }}
              >
                <Typography
                  variant="body1"
                  style={{
                    fontSize: 15,
                    fontWeight: "bold",
                    marginTop: initialItem?.mask ? 35 : 75,

                    marginBottom: 20,
                    marginLeft: 35,
                    color: theme.palette.mode === "light" ? "black" : "white",
                  }}
                >
                  {initialItem?.mask ?? ""}
                </Typography>
                {/* <Grid
                  container
                  style={{
                    maxHeight: "100%",
                    overflowY: "auto",
                    padding: 10,
                  }}
                >
                  <img
                    alt="ADA logo"
                    src={require("../../../assets/images/logo/robi_logo.png")}
                    style={{
                      width: 20,
                      height: 20,
                      marginTop: 0.5,
                      backgroundColor: "transparent",
                    }}
                  />
                  <Box
                    style={{
                      width: "200px",
                      marginLeft: 5,
                      borderRadius: "0 20px 20px 20px",
                      minHeight: 30,
                      backgroundColor: theme.palette.mode === "light" ? "#efefef" : "#1f242b",
                    }}
                  >
                    {initialItem?.message ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: initialItem?.message.replace("\n", "<br/>"),
                        }}
                        style={{
                          padding: 10,
                          inlineSize: "100%",
                          overflowWrap: "break-word",
                        }}
                      />
                    ) : null}
                  </Box>
                </Grid> */}
                <Grid
                  container
                  style={{
                    maxHeight: "100%",
                    overflowY: "auto",
                    padding: 10,
                  }}
                >
                  <Avatar sx={{ width: 20, height: 20, marginTop: 0.5 }}>
                    {/* <SimCardIcon sx={{ width: 20, height: 20, marginTop: 0.5 }} /> */}
                  </Avatar>
                  <Box
                    style={{
                      width: "200px",
                      marginLeft: 5,
                      borderRadius: "0 20px 20px 20px",
                      backgroundColor: theme.palette.mode === "light" ? "#efefef" : "#1f242b",
                      minHeight: 30,
                    }}
                  >
                    {initialItem?.message ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: initialItem?.message.replace("\n", "<br/>"),
                        }}
                        style={{
                          padding: 10,
                          inlineSize: "100%",
                          overflowWrap: "break-word",
                        }}
                      />
                    ) : null}
                  </Box>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default ApproveSmsBulkCampaign;
